import React from "react";

const CreateProfile = () => {
  return <p>Create Profile</p>;
};

export default CreateProfile;
